<template>
  <div class="physicalContainer">
    <div class="physical w">
      <div class="title">
        <div class="phyTitle">包裹信息</div>
        <ul>
          <li>运单号码：{{ timelineAllList.mailNo }}</li>
          <li>物流公司：{{ $route.query.transtype }}</li>
          <!-- <li>客服电话：95554</li> -->
        </ul>
      </div>
      <div class="tabletTimeline" v-if="timelineAllList.fullTraceDetail">
        <div class="titleList">
          <ul>
            <li class="liStyle">{{ timelineAllList.logisticsStatusDesc }}</li>
            <li>更新时间</li>
            <li style="width: 300px">物流信息</li>
          </ul>
        </div>
        <div class="timelineContent">
          <el-timeline :reverse="true">
            <el-timeline-item
              v-for="(item, index) in timelineAllList.fullTraceDetail"
              :key="item.id"
              :color="
                index == timelineAllList.fullTraceDetail.length - 1 ? 'red' : ''
              "
              size="normal"
            >
              <div class="date">
                {{ item.time }}
              </div>
              <div class="remark">
                {{ item.desc }}
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="btns clearfix">
          <div class="line"></div>
          <div class="btnTitle">
            收货后请及时点击确认收货，系统默认10天后自动确认收货!
          </div>
          <div class="button">
            <div class="btn btn1">确认收货</div>
            <div class="btn btn2" @click="$router.push('/order')">
              返回订单管理
            </div>
          </div>
        </div>
      </div>
      <div v-else><el-empty description="暂无物流信息"></el-empty></div>
    </div>
  </div>
</template>

<script>
import { getprogress } from "@/api";
export default {
  data() {
    return {
      timelineAllList: {},
    };
  },
  methods: {
    async getprogressList(trantype, kdnum) {
      let usercode = window.sessionStorage.getItem("usercode");
      let token = window.sessionStorage.getItem("token");
      const res = await getprogress({
        usercode,
        token,
        trantype,
        kdnum,
      });
      this.timelineAllList = res;
      // console.log(res);
    },
  },
  mounted() {
    this.getprogressList(this.$route.query.transtype, this.$route.query.kdnum);
  },
};
</script>

<style lang="less" scoped>
.physicalContainer {
  margin: 20px 0;

  .line {
    margin: 15px 0;
    width: 95%;
    margin-left: 20px;
    border: 1px dashed #ccc;
  }

  .physical {
    font-size: 14px;
    .btns {
      padding: 0 20px;
      margin-bottom: 40px;

      .btnTitle {
        float: left;
        color: #e61b23;
        font-size: 14px;
        padding-left: 50px;
        margin-top: 10px;
      }

      .button {
        float: right;
        display: flex;

        .btn1 {
          background: #e4040c;
        }

        .btn2 {
          background-color: #666666;
          margin-left: 15px;
        }

        .btn {
          cursor: pointer;
          font-size: 14px;
          width: 110px;
          height: 40px;
          line-height: 40px;
          color: #fff;
          text-align: center;
          border-radius: 5px;
        }
      }
    }

    border: 1px solid #cccccc;

    .tabletTimeline {
      .timelineContent {
        .el-timeline-item {
          line-height: 20px;
          padding-bottom: 40px;
        }

        padding: 20px 25px 0 25px;
        margin: 20px 25px 0 25px;
        background-color: #f3f4f6;

        .date {
          float: left;
          margin: 0 35px;
          color: #333333;
        }

        .remark {
          color: #676769;
        }
      }

      .titleList {
        padding: 0 50px;

        ul {
          padding-top: 25px;
          display: flex;
          border-bottom: 1px dashed #ccc;

          .liStyle {
            width: 50px;
          }

          li {
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            width: 200px;
          }
        }
      }
    }

    .title {
      background-color: #f3f4f6;
      display: flex;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #cccccc;

      .phyTitle {
        color: #000;
        font-size: 16px;
        font-weight: 600;
        padding-left: 40px;
      }

      ul {
        padding-left: 50px;
        display: flex;

        li {
          padding: 0 10px;
          color: #333436;
        }
      }
    }
  }
}
</style>
